import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../styles/form.scss';
const Loading = () => {
    const logoSrc = useSelector((state) => state.branding.partnerLogoSrc || '');
    return (React.createElement("div", { className: styles.background },
        React.createElement("div", { className: styles.container },
            React.createElement("img", { alt: 'Logo', className: styles.logo, src: logoSrc }),
            React.createElement("div", { className: styles.form },
                React.createElement("div", { className: styles.form_content },
                    React.createElement("h2", { className: styles.title_centered }, "Loading..."))))));
};
export default Loading;
